import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { AdminAnnouncementDTO } from '../../openapi/shell-service-openapi';

/**
 * EntityAdapter für Announcements.
 *
 * Normalisiert die Entity-Speicherung (ids[] + entities{}).
 */
export const announcementEntitiesAdapter: EntityAdapter<AdminAnnouncementDTO> =
  createEntityAdapter<AdminAnnouncementDTO>();
